/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import {
  Row,
  Col,
  Modal,
  Button,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import Work from './Work';
import Pair from './Pair';
import Electric from './Electric';
import styles from '../styles.scss';

const kInitalState = {
  status: '',
};

const propTypes = {
  intl: intlShape.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onAdded: PropTypes.func.isRequired,
  updateNodes: PropTypes.any.isRequired,
  deletePair: PropTypes.object.isRequired,
  networkDetail: PropTypes.object.isRequired,
};

class CreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitStatus: '',
      show: props.show,
      resetComponent: 0,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.pairs.create');
    this.allNodes = [];
    this.allParis = [];
    this.addQueue = [];
    this.checkedPairs = [];
    this.pairRemarks = {};
    this.deletePair = props.deletePair;
    this.networkDetail = props.networkDetail;
    this.onHide = this.onHide.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onWorkNodes = this.onWorkNodes.bind(this);
    this.onRemovePairs = this.onRemovePairs.bind(this);
    this.onCheckedPairs = this.onCheckedPairs.bind(this);
    this.onElectricNodes = this.onElectricNodes.bind(this);
  }

  componentWillReceiveProps({ show, networkDetail, deletePair, updateNodes }) {
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.networkDetail = networkDetail;
    }
    if (!_.isEqual(deletePair, this.deletePair)) {
      this.deletePair = deletePair;
      this.resetNodes();
    }
    if (updateNodes !== this.props.updateNodes) {
      this.resetNodes();
    }
  }

  onWorkNodes(nodes) {
    const checkedWorkNodes = _.concat(nodes, []);
    this.setState({ checkedWorkNodes });
  }

  onElectricNodes(nodes) {
    const checkedElectricNodes = _.concat(nodes, []);
    this.setState({ checkedElectricNodes });
  }

  onCheckedPairs(pairs, remarks) {
    this.pairRemarks = Object.assign({}, remarks);
    this.checkedPairs = _.concat(pairs, []);
  }

  onRemovePairs(array) {
    const workNode = array[0];
    const electricNode = array[1];
    if (workNode) {
      this.setState({ deleteWorkNode: workNode });
    }
    if (electricNode) {
      this.setState({ deleteElectricNode: electricNode });
    }
  }

  onHide() {
    this.setState({
      ...kInitalState,
      checkedWorkNodes: [],
      checkedElectricNodes: [],
      resetComponent: new Date().valueOf(),
    });
    this.props.onHide();
  }

  onSubmit() {
    const { id } = this.networkDetail.data;
    const pairs = [];
    _.forEach(this.checkedPairs, (items) => {
      if (!items[0] || !items[1]) return;

      const memo = {};
      const workNode = items[0];
      const electricNode = items[1];
      if (workNode.memo) {
        const memo1 = JSON.parse(workNode.memo);
        memo.name = memo1.name;
      }
      if (electricNode.memo) {
        const memo2 = JSON.parse(electricNode.memo);
        memo.rname = memo2.name;
      }
      const remark = this.pairRemarks[workNode.id] || this.pairRemarks[electricNode.id];
      memo.remark = remark;

      pairs.push({
        netw: id,
        id: workNode.id,
        service: 2,
        rnode: electricNode.id,
        rservice: 4,
        memo: JSON.stringify(memo),
      });
    });
    if (!pairs.length) return;

    this.addQueue = _.concat(this.addQueue, pairs);
    const addFunc = () => {
      if (this.addQueue.length > 0) {
        const pair = this.addQueue.pop();
        callAPI({
          method: 'POST',
          endpoint: '/tdmng/pairs',
          body: { ...pair },
        }).then(() => {
          addFunc();
        }).catch(() => {});
      } else {
        this.setState({ submitStatus: 'success' });

        _.delay(() => {
          this.props.onAdded();
          this.props.onHide();
          this.resetNodes();
        }, 250);
      }
    };
    addFunc();
  }

  resetNodes() {
    this.setState({
      checkedWorkNodes: [],
      checkedElectricNodes: [],
      resetComponent: new Date().valueOf(),
    });
  }

  render() {
    const {
      show,
      submitStatus,
      resetComponent,
      deleteWorkNode = {},
      deleteElectricNode = {},
      workNodes = [],
      electricNodes = [],
      checkedWorkNodes = [],
      checkedElectricNodes = [],
    } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-light"
        backdrop="static"
        show={show}
        onHide={this.onHide}
        className={styles.pairs}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('header')}
        </Modal.Header>
        <Modal.Body>
          <Row className={styles.header}>
            <Col md={3}>{this.intlMsg.msg('title.work')}</Col>
            <Col md={6}>Pairs</Col>
            <Col md={3}>{this.intlMsg.msg('title.params')}</Col>
          </Row>
          <Row className={styles.body}>
            <Col md={3}>
              <Work
                nodes={workNodes}
                onChecked={this.onWorkNodes}
                deleteNode={deleteWorkNode}
                resetComponent={resetComponent}
              />
            </Col>
            <Col md={6} className={styles.pair}>
              <Pair
                onChecked={this.onCheckedPairs}
                workNodes={checkedWorkNodes}
                electricNodes={checkedElectricNodes}
                onRemove={this.onRemovePairs}
                resetComponent={resetComponent}
              />
            </Col>
            <Col md={3}>
              <Electric
                nodes={electricNodes}
                onChecked={this.onElectricNodes}
                deleteNode={deleteElectricNode}
                resetComponent={resetComponent}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-default"
            onClick={this.onHide}
            className={styles.white}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
          <Button
            bsStyle="aisz-success"
            onClick={this.onSubmit}
            disabled={submitStatus === 'pending'}
          >
            {submitStatus === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
            {this.intlMsg.msg('confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

CreateModal.propTypes = propTypes;

const mapStateToProps = state => ({
  updateNodes: state.tdm.updateNodes,
  networkDetail: state.tdm.getNetwork,
});

export default connect(mapStateToProps)(injectIntl(CreateModal));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Pairs/CreateModal.jsx